module.exports = __webpack_public_path__ + "img/187.0aaf6182.jpg";